import React from 'react';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';

import { Controls } from '../../components/controls/Controls';
import Form from '../../components/useForm';
import ServiceButtonWithToast from '../_common/ServiceButtonWithToast';

export const dxHxDefaultValues = {
  dxHxName: '',
};

export default function DxHxForm(props) {
  const {
    values, handleInputChange, onSubmit, onSuccess, successMsg, errorMsg,
  } = props;

  const handleSubmit = () => onSubmit(values);

  return (
    <Form>
      <Grid container>
        <Grid item xs={10}>
          <Controls.Input
            label="DxHx Name"
            name="dxHxName"
            value={values.dxHxName}
            onChange={handleInputChange}
          />
          <Grid container justifyContent="flex-end">
            <ServiceButtonWithToast
              buttonText="Save"
              service={handleSubmit}
              onSuccess={onSuccess}
              successMsg={successMsg}
              errorMsg={errorMsg}
            />
          </Grid>
        </Grid>
      </Grid>
    </Form>
  );
}

DxHxForm.propTypes = {
  values: PropTypes.shape({
    dxHxName: PropTypes.string,
  }).isRequired,
  handleInputChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  successMsg: PropTypes.string.isRequired,
  errorMsg: PropTypes.string.isRequired,
};
